module.exports = __webpack_public_path__ + "img/bell-off.948574cf.svg";